export function getTransformedParentElement(element) {
  let currentElement = element.parentElement;
  while (currentElement) {
    const computedStyle = window.getComputedStyle(currentElement);
    const transformValue = computedStyle.getPropertyValue('transform');
    if (transformValue !== 'none') {
      return currentElement;
    }
    currentElement = currentElement.parentElement;
  }
  return null;
}